import styled from '@emotion/styled'
import { CUSTOM_SCROLLBAR } from '@helpers/styles'
import { Box, Drawer as MuiDrawer, type Theme } from '@mui/material'

const DRAWER_WIDTH = 220

export const Drawer = styled(MuiDrawer)`
	background-color: transparent;
	flex-shrink: 0;
	overflow-x: hidden;
	white-space: nowrap;

	&:hover {
		width: ${DRAWER_WIDTH}px;
	}

	${({ theme }: { theme: Theme }) => `
		transition: ${theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		})};
		width: ${theme.spacing(7)};

		${theme.breakpoints.up('sm')} {
			width: ${theme.spacing(8)};
		}
	`}

	& .MuiPaper-root {
		border: 0;
		background-color: 'transparent';
		overflow-x: hidden;

		${CUSTOM_SCROLLBAR.scrollbarCustomVertical}

		&:hover {
			width: ${DRAWER_WIDTH}px;
		}

		${({ theme }: { theme: Theme }) => `
			transition: ${theme.transitions.create('width', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			})};
			width: ${theme.spacing(7)};

			${theme.breakpoints.up('sm')} {
				width: ${theme.spacing(8)};
			}
		`}
	}
`

export const Toolbar = styled.div`
	display: flex;
	align-items: center;
	${({ theme }: { theme: Theme }) => `
		padding: ${theme.spacing(0, 0)};
	`}
`

export const MenuButtonBox = styled(Box)`
	${({ theme }: { theme: Theme }) => `
		height: ${theme.spacing(6)};
		width: ${theme.spacing(6)};
	`}
`

export const BottomDiv = styled.div`
	margin-top: auto;
`
